import {
	primaryGradient, secondaryGradient,
} from 'root/src/client/web/commonStyles'

const styles = {
	section: {
		lineHeight: '24px',
		fontFamily: 'Roboto, sans-serif',
		paddingBottom: 38,
	},
	sectionTitle: {
		fontSize: 32,
		fontWeight: 'bold',
		marginTop: -20,
		marginBottom: 0,
		textAlign: 'center',
	},
	button: {
		margin: '0 auto',
		display: 'flex',
		width: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		maxWidth: 360,
		marginTop: 45,
		borderRadius: 4,
		fontSize: 18,
		boxShadow: '0 5px 6px 0 rgba(0, 0, 0, 0.16)',
		textTransform: 'none',
		cursor: 'pointer',
		color: 'white',
		backgroundImage: primaryGradient,
		'&:hover': {
			backgroundImage: secondaryGradient,
		},
		height: 42,
		border: 'none',
	},
	link: {
		textDecoration: 'none',
	},
}

export default styles
